export default "__VITE_ASSET__4yRpWf8J__"